import React from "react";
import { OldButton as Button } from "digiwash-components";
import Icon from "../Icon";

interface ButtonHeaderBackProps {
  onBackClick: () => void;
}

function ButtonHeaderBack(props: ButtonHeaderBackProps) {
  return (
    <Button onPress={props.onBackClick}>
      <Icon name="chevron-right" size={32} color="primary.light950" />
    </Button>
  );
}

export default ButtonHeaderBack;
